export const configStyles = {
  root: {
    height: "100%",
    minHeight: "430px",
    maxHeight: "470px",
    marginTop: "10px",
    overflowY: "auto",
    padding: "15px",
  },
  tableContainer: {
    flexgrow: 1,
    maxHeight: "600px", // Maximum height
    minHeight: "400px", // Minimum height
    width: "100%", // Ensure full width
    borderRadius: "10px",
    overflowY: "auto", // Scroll if content exceeds height
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "0px", // Hide scrollbar initially
      transition: "width 0.3s ease",
    },
    "&:hover::-webkit-scrollbar": {
      width: "8px", // Show scrollbar on hover
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#666",
      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  },

  mainTable: {
    display: "flex",
    width: "100%", // Full width
    height: "calc(100vh - 16.5vh)", // Full height minus header height
    minHeight: "400px", // Minimum height
    maxHeight: "800px", // Maximum height
    padding: "16px",
    marginTop: "16px",
    overflowY: "auto", // Allow vertical scrolling if content exceeds height
    overflowX: "hidden", // Hide horizontal scrolling
    "&::-webkit-scrollbar": {
      width: "8px", // Scrollbar width
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888", // Scrollbar thumb color
      borderRadius: "4px", // Rounded scrollbar thumb
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#666", // Darker color on hover
      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)", // Subtle shadow effect
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent", // Transparent scrollbar track
    },
  },
};
